import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, portfolio, project }) =>
    present(
      repository
        .saveProjectInPortfolio(planzone, portfolio, project)
        .then(() => ({ planzone, portfolio, project }))
        .catch(() => Promise.reject({ planzone, portfolio, project })),
    );
}

export type { Interactor };

export { createInteractor };
